
class Table2Lib {
  public _getIndexNameByCellType(cellType: string, index: string) {
    switch (cellType) {
      case 'sno':
        return '__sno';
      default:
        return index || '';
    }
  }

  // tslint:disable-next-line: member-ordering
  public defaults: any = {
    grid: {
      height: 'calc(65vh - 70px)'
    }
  };
  public getFieldValue(obj, prop, col) {
    let value;
    value = Number(obj[prop]);
    if (!isNaN(value)) {
      return value;
    }
    let isDate = false;
    const dateCols = ['month', 'date'];
    dateCols.map((date) => {
      if (col.name && col.name.toLowerCase().search(date) > -1) {
        isDate = true;
      }
    });
    if (isDate) {
      value = obj[prop];
      value = value.split('-').reverse().join('-');
      return value;
    }
    return obj[prop];
  }
  public swap(obj1, obj2, prop, sortDir, col) {
    console.error('Swaping ', obj1, obj2, col);
    let obj1_prop, obj2_prop;
    try {

    } catch (e) {

    }
    obj1_prop = this.getFieldValue(obj1, prop, col),
      obj2_prop = this.getFieldValue(obj2, prop, col);
    return ((sortDir === 'A' && obj1_prop > obj2_prop) || (sortDir === 'D' && obj1_prop < obj2_prop));
  }

  public doSorting(columns: any[], rows: any, col: any, sortDir = '') {
    const compare = function (obj1, obj2) {
      const obj1_prop = this.getFieldValue(obj1, col.prop, col),
        obj2_prop = this.getFieldValue(obj2, col.prop, col);
      const offset = (sortDir === 'A') ? 1 : -1;
      if (obj1_prop > obj2_prop) {
        return -1 * offset;
      }
      if (obj1_prop < obj2_prop) {
        return 1 * offset;
      }
      return 0;

    }.bind(this);
    let srws: any[] = rows.map(x => Object.assign({}, x)),
      sort = false;
    while (sort) {
      sort = false;
      for (let i = 0, j = 1; i < srws.length - 1; i++ , j++) {
        const obj1 = srws[i],
          obj2 = srws[j];
        if (this.swap(obj1, obj2, col.prop, sortDir, col)) {
          srws[j] = obj1,
            srws[i] = obj2;
          sort = true;
        }
      }
    }
    srws = srws.sort(compare);
    let __sno = 1;
    srws.map((row) => {
      row.sno = __sno++;
    });
    return srws;
  }
}

import { Component, Injectable, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'table2',
  templateUrl: './table2.component.html',
  styles: [`tr.yearlytarget th{font-size:22px;color:crimson;}`]})

@Injectable()
export class Table2 extends Table2Lib implements OnInit {
  static table2_id = 0;
  gridOptions: any;
  tableHistory: any;
  colList = [];
  columnList = [];
  selectedItems = [];
  allColumns = [];
  tableData: any;
  not_checkrow : boolean = true;
  temp_row = [];
 
  showButton = false;
  showSelect = false;
  @Input()
  screenName: string;

  @Input() tableOption: any;
  @Input() iscomponent: any;
  
  @Input()
  set options(val: any) {
    let saveHistory = false;
    if (val['data']) {
      saveHistory = true;
    } else {
      val['data'] = [];
    }
    this.gridOptions = Object.assign(this.gridOptions, val)
console.log("call fro", this.gridOptions)
    if (val.screenName == "salesOrdercancelReport") {
      this.gridOptions.actionRow = false;
    } else {
      this.gridOptions.actionRow = true;
    }

    if (val['columns']) {
      this.renderColumns();
    }
    this.showSelect = val['showSelect'];
    this.columnList = [];
    // this.displayColumns();
    this.gridOptions.columns.forEach(element => {

      this.columnList.push(element.name);
      this.colList = this.columnList;
    });
    this.allColumns = [];

    this.allColumns = this.gridOptions.columns;
    this.start();
    if (val['columns']) {
      this.applyStyle();
    }
    this.applyCSS();
    if (saveHistory) {
      this.saveHistory();
    }

  }
  get options() {
    return this.gridOptions;
  }
  @Output() onCellClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() prevClick: EventEmitter<any> = new EventEmitter<any>();
  // @Output() checkBoxClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSorting : EventEmitter<any> = new EventEmitter<any>();


  tableId: number;
  constructor() {
    super();
    this.tableId = Table2.table2_id++;
    this.gridOptions = {
      loading: false,
      tableId: this.tableId,
      height: this.defaults.grid.height
    };

    this.tableData = {
      columns: [],
      dispRows: [],
      summaryrow: {},
      rows: [],
      sortBy: '',
      sortDir: 'A'
    };

    this.tableHistory = {
      ind: -1,
      data: []
    };
  }
  ngOnInit() {
    //c//onsole.log('Table2-' + this.tableId + ' Created.');
  }
  cellClicked(row, col, prop, value, rindex, cindex) {

    this.onCellClick.emit({
      row: row,
      column: col,
      property: prop,
      value: value,
      rowIndex: rindex,
      columnIndex: cindex
    });
    this.showButton = true;
  }

  loadNextData() {


    const tabHistory = this.tableHistory;
    if (tabHistory.ind < (tabHistory.data.length - 1)) {
      tabHistory.ind++;
      this.tableData = Object.assign({}, tabHistory.data[tabHistory.ind]);
    }
  }
  
  loadPrevData(row, col, prop, value, rindex, cindex) {

    const tabHistory = this.tableHistory;

    tabHistory.data.splice(-1);
    if (tabHistory.ind > 0) {
      tabHistory.ind--;
      this.tableData = Object.assign({}, tabHistory.data[tabHistory.ind]);
    }
    this.prevClick.emit({
      row: row,
      column: col,
      property: prop,
      value: value,
      rowIndex: rindex,
      columnIndex: cindex
    });
    this.showButton = false;
  }
  start(style: boolean = true) {
    this.renderRows();
    this.getSummaryRow();
    // this.applyCSS();
  }

  saveHistory() {
    const tabHistory = this.tableHistory;
    tabHistory.ind++;
    if (tabHistory.ind > 0 && tabHistory.ind < tabHistory.data.length) {
      //      tabHistory.data.splice(tabHistory.ind +1, tabHistory.data.length - tabHistory.ind-1);
    }
    tabHistory.data.push(Object.assign({}, this.tableData));
    tabHistory.ind = tabHistory.data.length - 1;
  }

  renderColumns() {
    this.tableData.columns = [];
    let data = this.gridOptions.data.map(x => Object.assign({}, x)),
      columns = this.gridOptions.columns.map(x => Object.assign({}, x)),
      cols = [],
      rows = [],
      row, ind, type, val,
      rlen = data.length,
      clen = columns.length;
    //For removing Back Button In table2 Grid For PartyValueWise Report
    columns.forEach(el => {
      if (el.prop == "per" || el.prop=="avl_comm" || el.prop === "f_avg" ||  el.prop == "formal_total" || el.prop == "colno" || el.prop === "fqtys") {
        this.showButton = false;

      }
    });

    for (let i = 0; i < clen; i++) {

      const col = columns[i],
        name = col.name || 'Column ' + (i + 1),
        index = this._getIndexNameByCellType(col.type, col.index),
        width = col.width || 100,
        background = col.background,
        fontColor = col.fontColor,
        fontWeight = col.fontWeight || '700',
        fontSize = col.fontSize || 15,
        borderRight = col.borderRight,
        borderBottom = col.borderBottom,
        borderLeft = col.borderLeft,
        type = col.type || 'value',
        gSummary = col.gSummary || 'none',
        fSummary = col.fSummary || 'none',
        cellClass = col.cellClass || '',
        headerClass = col.headerClass || '';

      cols.push({
        name: name,
        prop: col.prop,
        index: index,
        summaryClass: (col.summary == 'sum') ? '' : '',
        type: type,
        summary: col.summary || 'none',
        cellClass: cellClass,
        headerClass: headerClass,
        width: width + 'px',
        fontSize: fontSize + "px",
        fontWeight: fontWeight,
        borderRight: col.borderRight,
        borderBottom: col.borderBottom,
        borderLeft: col.borderLeft,
        background: background,
        fontColor: fontColor,
        gSummary: gSummary,
        fSummary: fSummary
      });
    }
    this.tableData.columns = cols;

  }
  renderRows() {
    let data = this.gridOptions.data.map(x => Object.assign({}, x)),
      columns = this.gridOptions.columns.map(x => Object.assign({}, x)),
      cols = this.tableData.columns,
      rows = [],
      row, ind, type, val,
      rlen = data.length,
      clen = columns.length;
    for (let i = 0; i < rlen; i++) {
      const tempRow = { ...data[i] };
      if (this.showSelect) {
        tempRow['isSelect'] = false;
        this.not_checkrow = true;
      }
      row = Object.assign({}, tempRow);
      for (let j = 0; j < clen; j++) {
        const type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop;
        switch (type) {
          case 'sno':
            val = i + 1;
            row[prop] = val;
            break;
          case 'date':

            break;
          default:
            break;
        }
      }
      rows.push(row);
    }

    this.tableData.rows = rows;
    this.tableData.dispRows = this.tableData.rows.map(x => Object.assign({}, x));
  }
  displayColumns(columns, data) {
    // let index = this.gridOptions.columns.indexOf(data)
    // this.gridOptions.columns.splice(index,1);
    const temp = [];

    // this.gridOptions.columns.forEach(element => {
    //   if (data !== element.name) {
    //     //  let temp = this.gridOptions.columns;
    //     //   this.gridOptions.columns.remove(1);
    //     temp.push(element);
    //   }
    // });
    // this.gridOptions.columns = temp;
    this.gridOptions.columns = [];
    this.allColumns.forEach(element => {
      columns.forEach(element1 => {
        if (element.name == element1) {
          this.gridOptions.columns.push(element);
        }
      });

    });



    this.renderColumns();
    this.applyCSS();
  }
  getDateFormat(date) {
    const d = date.split('-'),
      fd = d[2] + '-' + d[1] + '-' + d[0];
    return fd;
  }
  onselectItem(evant) {

  }

  moneyFormat(nStr) {
    if (nStr == null || nStr == undefined || nStr == '' || nStr == 0)
      return 0.00;
    const no = parseFloat(nStr).toFixed(2);
    /*if (no < 0) {
        nStr = no * -1;
    }
    nStr += '';*/

    const x = no.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    let z = 0;
    const len = (x1).length;
    const num = ((len / 2) - 1);
    let newval = Math.floor(num);

    while (rgx.test(x1)) {
      if (z > 0) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      } else {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
        rgx = /(\d+)(\d{2})/;
      }
      z++;
      newval--;
      if (newval == 0) {
        break;
      }
    }

    let out = x1 + x2;
    if (Number(no) < 0) {
      out = '(' + out + ')';
    }
    return out;

  }
  calcPcs(type) {
    let tem = this.temp_row.findIndex(e => e.sales_type == type.sales_type);
    if (tem == -1) {
      this.temp_row.push(type)
    }
    else {
      this.temp_row.splice(tem, 1);
    }
    this.tableData.rows = this.temp_row;
    const data = this.tableData.rows,
      columns = this.tableData.columns,
      row = {
        type: 'summary'
      };
    for (let i = 0; i < columns.length; i++) {
      const col = columns[i];
      switch (col.summary) {
        case 'sum':
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j],
              val = parseFloat(dat[col.prop]);
            val = (isNaN(val)) ? 0 : val;
            total += val;

          }
          row[col.prop] = Math.round(total * 100) / 100;
          row[col.prop] = this.moneyFormat(row[col.prop]);
          break;
      }
    }


  }

  getSummaryRow() {
    this.not_checkrow = true;
    const data = this.tableData.rows,
      columns = this.tableData.columns,
      row = {
        type: 'summary'
      };
    for (let i = 0; i < columns.length; i++) {
      const col = columns[i];
      switch (col.summary) {
        case 'sum':
          let total = 0;
          let tem_total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j],
              val = parseFloat(dat[col.prop]);
            val = (isNaN(val)) ? 0 : val;
            if ((this.showSelect && dat.isSelect) || !this.showSelect) {
              this.not_checkrow = false;
              total += val;
            
            }
            else if (this.showSelect && !dat.isSelect) {
              tem_total += val;
      
   
            }
          }
          if(this.screenName == 'partysalesvalueReport') { 
            row[col.prop] = Math.round((total * 100)) / 100;
          }
          else {
            row[col.prop] = Math.round((total * 100)) / 100; 
            row[col.prop] = this.moneyFormat(row[col.prop]);
          }
        //For (ValueWise Report) CheckBox Not checked- total
          if (row[col.prop] == 0 && this.showSelect && this.not_checkrow) {
            row[col.prop] = Math.round(tem_total * 100) / 100;
             row[col.prop] = this.moneyFormat(row[col.prop]);
           }

          break;
        case 'tot':
          let total1 = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j],

              val = parseInt(dat[col.prop]);

            val = (isNaN(val)) ? 0 : val;
            if ((this.showSelect && dat.isSelect) || !this.showSelect)
              total1 += val;



          }
          if (col.prop == 'ord_tgt_avg') {

            total1 = total1 / data.length;

          }
          else if (col.prop == 'sales_tgt_avg') {

            total1 = total1 / data.length;

          }
          else if (col.prop == 'avg_pcs') {

            total1 = total1 / data.length;

          }
          else if (col.prop == 'ordered_pcs_avg') {

            total1 = total1 / data.length;

          }
          else if (col.prop == 'non_order_pcs_avg') {

            total1 = total1 / data.length;

          }
           row[col.prop] = Math.round(total1 * 100) / 100;

          break;
        case 'cnt':
          let total3 = data.length;
          row[col.prop] = total3;
          break;
        default:
          row[col.prop] = '';
          break;
      }
    }
    this.tableData.summaryrow = row;
    // console.log("total1",this.tableData.summaryrow);
    if(this.tableData.summaryrow.dly_plan_avg > 0){
      this.tableData.summaryrow.dly_plan_avg = (this.tableData.summaryrow.tot_qty/this.tableData.summaryrow.actual_days).toFixed(0);
    }
    //this.tableData.summaryrow = parseFloat(this.tableData.summaryrow);
    // For Plain Order Report Grid Avg Calculation
   if(this.tableData.summaryrow.fqtys > 0 || this.tableData.summaryrow.hqtys > 0){
    this.tableData.summaryrow.fs_avg = ((this.tableData.summaryrow.fqtys / this.tableData.summaryrow.tot_pcs) * 100).toFixed(2)
    this.tableData.summaryrow.hs_avg = ((this.tableData.summaryrow.hqtys / this.tableData.summaryrow.tot_pcs) * 100).toFixed(2)
    this.tableData.summaryrow.style_avg = ((this.tableData.summaryrow.tot_pcs / this.tableData.summaryrow.tot_pcs) * 100).toFixed(2)
    this.tableData.summaryrow.variety_avg = ((this.tableData.summaryrow.tot_pcs / this.tableData.summaryrow.tot_pcs) * 100).toFixed(2)
   }
   if(this.iscomponent){
    this.tableData.summaryrow.ord_per = ((this.tableData.summaryrow.ord_total / this.tableData.summaryrow.ordplan_tot) * 100).toFixed(2)

    this.tableData.summaryrow.sales_per = ((this.tableData.summaryrow.del_total / this.tableData.summaryrow.salesplan_tot) * 100).toFixed(2)
   } 
  }

  sort(col) {
    this.gridOptions.loading = true;
    let cprop = col.prop,
      sortBy = this.tableData.sortBy,
      rows = this.tableData.rows,
      cols = this.tableData.columns,
      sortDir = this.tableData.sortDir;
    if (cprop === sortBy) {
      switch (sortDir) {
        case 'A':
          sortDir = 'D';
          break;
        case 'D':
          sortDir = '';
          break;
        default:
          sortDir = 'A';
          break;
      }
    } else {
      sortBy = cprop;
      sortDir = 'A';
    }
    this.tableData.sortBy = sortBy;
    this.tableData.sortDir = sortDir;
    const that = this;
    setTimeout(function () {
      const dispRows = that.doSorting(cols, rows, col, sortDir);
      that.tableData.dispRows = dispRows;
      that.gridOptions.loading = false;
      that.onSorting.emit({rows : that.tableData.dispRows})
    }, 200);
  }
  applyStyle() {
  }

  applyCSS() {
    const that = this;
    setTimeout(function () {
      let tid = that.tableId,
        scrollDiv = '#t2-' + tid + ' .t2-canvas.t2-cf',
        hDiv = '#t2-' + tid + ' .t2-canvas.t2-ch',
        bDiv = '#t2-' + tid + ' .t2-canvas.t2-cb',
        footDiv = '#t2-' + tid + ' #t2-foot-div',
        footDivTable = '#t2-' + tid + ' #t2-foot-div table',
        width = $(footDivTable).width() + 1;
      $(footDiv).width(width + 'px');

      document.querySelector(scrollDiv)['onscroll'] = function () {
        const left = document.querySelector(scrollDiv).scrollLeft;
        document.querySelector(hDiv).scrollLeft = left,
          document.querySelector(bDiv).scrollLeft = left;
      };
      width = that.gridOptions.maxHeight || 'calc(65vh - 70px)';
      const cb = document.querySelector('#t2-' + tid + ' .t2-canvas.t2-cb');
      cb['style'].maxHeight = width;
      cb['style'].minHeight = width;
      document.querySelector('#t2-' + tid + ' .t2-canvas.t2-cb')['style'].overflowY = 'scroll';
      'scroll';
    }, 700);
  }

  check() {

  }

  selectRow(ind, event) {

    this.tableData.rows[ind].isSelect = event.target.checked;
    this.tableData.dispRows[ind].isSelect = event.target.checked;
    this.getSummaryRow();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/common/table2/table2.component.ts